import String from '../String/String'
import { IStringInputSettings } from '../inputs.interface'
import { IInputStatus } from '../../../interface/progress.interface'
import { useDefaultString } from './useDefaultString'
import { IChangeValue } from '../../../interface/steps.interface'

interface Props {
  value: string
  name: string
  handleChange: IChangeValue
  checkChangeValue: Function
  status: IInputStatus
  settings: IStringInputSettings
  apiErrors: { [name: string]: string }
  dependenciesValue?: string | null
  inputType?: string
  progressTrigger?: Function
  tooltip?: string
}

export const DefaultString = ({
  value,
  name,
  handleChange,
  checkChangeValue,
  status,
  settings,
  apiErrors,
  inputType,
  progressTrigger,
  tooltip
}: Props) => {
  const {
    localValue,
    localStatus,
    inputRef,
    disabled,
    localSettings,
    handleLocalChange,
    handleKeydown,
    handlePaste,
    handleFocus,
    handleBlur,
  } = useDefaultString({
    value,
    name,
    handleChange,
    status,
    settings,
    checkChangeValue,
    progressTrigger
  })

  return (
    <String
      value={localValue}
      name={name}
      status={localStatus}
      disabled={disabled}
      apiErrors={apiErrors}
      innerRef={inputRef}
      settings={localSettings}
      handleChange={handleLocalChange}
      handleKeydown={handleKeydown}
      handlePaste={handlePaste}
      handleFocus={handleFocus}
      handleBlur={handleBlur}
      width={name === 'car_number' ? '272px' : '100%'}
      inputType={inputType ?? 'text'}
      tooltip={tooltip}
    />
  )
}
